/**
 * @generated SignedSource<<31723ec579147f27ac76f7b1b7b0c4a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTrackCurrentItemBase$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase" | "atomsCurrentNotificationSectionAtomBase" | "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase" | "atomsCurrentTakeoverAdSectionsAtomBase">;
  readonly " $fragmentType": "hooksTrackCurrentItemBase";
};
export type hooksTrackCurrentItemBase$key = {
  readonly " $data"?: hooksTrackCurrentItemBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTrackCurrentItemBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksTrackCurrentItemBase"
};

(node as any).hash = "a838df1567ccc1cc3ee365a3473bdfe3";

export default node;
